import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DBox({ className, style, children, dataAttributes, }) {
    return (_jsx("div", Object.assign({ style: style, className: classNames('d-box', className) }, dataAttributes, { children: children })));
}
//# sourceMappingURL=DBox.js.map